import { TextField, CircularProgress, InputAdornment } from '@mui/material';
import { QrCodeScanner as ScanIcon } from '@mui/icons-material';
import React from 'react';

interface ScanInputProps {
  inputValue: string;
  setInputValue: (val: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  isLoading: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
}

const ScanInput: React.FC<ScanInputProps> = ({
  inputValue,
  setInputValue,
  onKeyDown,
  isLoading,
  inputRef,
}) => {
  return (
    <TextField
      inputRef={inputRef}
      fullWidth
      variant="outlined"
      placeholder="Esperando escaneo"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={onKeyDown}
      disabled={isLoading}
      autoComplete="off"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <ScanIcon sx={{ color: '#ff7500', fontSize: 22 }} />
          </InputAdornment>
        ),
        endAdornment: isLoading ? (
          <InputAdornment position="end">
            <CircularProgress size={20} sx={{ color: '#ff7500' }} />
          </InputAdornment>
        ) : null,
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          fontSize: '1.1rem',
          borderRadius: '14px',
          backgroundColor: '#f9fafb',
          caretColor: 'transparent',
          '& fieldset': {
            borderColor: '#e5e7eb',
            borderWidth: '1.5px',
          },
          '&:hover fieldset': { borderColor: '#ff7500' },
          '&.Mui-focused fieldset': { borderColor: '#ff7500', borderWidth: '2px' },
        },
        '& .MuiOutlinedInput-input': {
          padding: '14px 12px',
        },
      }}
    />
  );
};

export default ScanInput;
